import { render, staticRenderFns } from "./UserGroupHeader.vue?vue&type=template&id=0fdc4d26&scoped=true&"
import script from "./UserGroupHeader.vue?vue&type=script&lang=js&"
export * from "./UserGroupHeader.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupHeader.vue?vue&type=style&index=0&id=0fdc4d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc4d26",
  null
  
)

export default component.exports